import { render } from "./ContributionChart.vue?vue&type=template&id=25228a40&ts=true"
import script from "./ContributionChart.vue?vue&type=script&lang=ts"
export * from "./ContributionChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__